import React, { useContext } from "react";
import ESOganisationDropdown from "../components/dropdown/esOrganisationDropdown";
import SectionHeader from "../components/section/SectionHeader";
import InfoAlert from "../ui/InfoAlert";
import OrgContext from "../store/orgContext";
import InlineLoader from "../components/loader/InlineLoader";
import NewCannedMessage from "../components/cannedMessage/NewCannedMessage";
import {
  CREATE_CANNED_MESSAGE_TRANSLATIONS,
  LOADING_TEXT_TRANSLATIONS,
} from "../translations/util";

const NewCannedMessages = () => {
  const { orgs: orgList, selectedOrg, updateOrg } = useContext(OrgContext);

  if (!orgList || orgList.length === 0) {
    return (
      <InlineLoader
        description={LOADING_TEXT_TRANSLATIONS.defaultLoadingText}
      />
    );
  }

  return (
    <>
      <SectionHeader
        pageTitle={CREATE_CANNED_MESSAGE_TRANSLATIONS.header}
        pageDescription={CREATE_CANNED_MESSAGE_TRANSLATIONS.headerSubtext}
        showBackButton
        sideComponent={
          <div className="dropdown-details">
            <ESOganisationDropdown
              disabled
              org={selectedOrg || undefined}
              orgsList={orgList}
              setOrg={updateOrg}
            />
          </div>
        }
      />

      <div className="main-content">
        {selectedOrg ? (
          <NewCannedMessage org={selectedOrg.id} />
        ) : (
          <InfoAlert
            heading={CREATE_CANNED_MESSAGE_TRANSLATIONS.infoAlert.heading}
            subText={CREATE_CANNED_MESSAGE_TRANSLATIONS.infoAlert.subText}
          />
        )}
      </div>
    </>
  );
};

export default NewCannedMessages;
